import { jqLiteAddClass, jqLiteRemoveClass } from "./jqlite";
let scrollLock = 0;
let _scrollBarWidth;
let scrollLockPos;
const scrollLockCls = "mui-scroll-lock";
let scrollStyleEl;
export function utilRequestAnimationFrame(callback) {
    var fn = window.requestAnimationFrame;
    if (fn)
        fn(callback);
    else
        setTimeout(callback, 0);
}
export function utilDispatchEvent(element, eventType, bubbles = true, cancelable = true) {
    const ev = document.createEvent("HTMLEvents");
    ev.initEvent(eventType, bubbles, cancelable);
    element.dispatchEvent(ev);
    return ev;
}
export function utilEnableScrollLock() {
    scrollLock += 1;
    if (scrollLock === 1) {
        let doc = document, win = window, htmlEl = doc.documentElement, bodyEl = doc.body, scrollBarWidth = getScrollBarWidth(), cssProps, cssStr, x;
        cssProps = ["overflow:hidden"];
        if (scrollBarWidth) {
            const bodyStyle = getComputedStyle(bodyEl);
            if (htmlEl && htmlEl.scrollHeight > htmlEl.clientHeight) {
                x =
                    parseInt(bodyStyle.getPropertyValue("padding-right")) + scrollBarWidth;
                cssProps.push("padding-right:" + x + "px");
            }
            if (htmlEl && htmlEl.scrollWidth > htmlEl.clientWidth) {
                x =
                    parseInt(bodyStyle.getPropertyValue("padding-bottom")) +
                        scrollBarWidth;
                cssProps.push("padding-bottom:" + x + "px");
            }
        }
        cssStr = "." + scrollLockCls + "{";
        cssStr += cssProps.join(" !important;") + " !important;}";
        scrollStyleEl = loadStyleFn(cssStr);
        win.addEventListener("scroll", scrollEventHandler, true);
        const docEl = document.documentElement;
        scrollLockPos = {
            left: docEl == null
                ? 0
                : (win.scrollX || docEl.scrollLeft) - (docEl.clientLeft || 0),
            top: docEl == null
                ? 0
                : (win.scrollY || docEl.scrollTop) - (docEl.clientTop || 0),
        };
        jqLiteAddClass(bodyEl, scrollLockCls);
    }
}
export function utilDisableScrollLock(resetPos) {
    if (scrollLock === 0)
        return;
    scrollLock -= 1;
    if (scrollLock === 0) {
        jqLiteRemoveClass(document.body, scrollLockCls);
        scrollStyleEl.parentNode.removeChild(scrollStyleEl);
        if (resetPos)
            window.scrollTo(scrollLockPos.left, scrollLockPos.top);
        window.removeEventListener("scroll", scrollEventHandler, true);
    }
}
function getScrollBarWidth() {
    if (_scrollBarWidth !== undefined)
        return _scrollBarWidth;
    let doc = document, bodyEl = doc.body, el = doc.createElement("div");
    el.innerHTML =
        '<div style="width:50px;height:50px;position:absolute;' +
            'left:-50px;top:-50px;overflow:auto;"><div style="width:1px;' +
            'height:100px;"></div></div>';
    el = el.firstChild;
    bodyEl.appendChild(el);
    _scrollBarWidth = el.offsetWidth - el.clientWidth;
    bodyEl.removeChild(el);
    return _scrollBarWidth;
}
function loadStyleFn(cssText) {
    let doc = document, head;
    head = doc.head || doc.getElementsByTagName("head")[0] || doc.documentElement;
    const e = doc.createElement("style");
    e.type = "text/css";
    if (e.styleSheet)
        e.styleSheet.cssText = cssText;
    else
        e.appendChild(doc.createTextNode(cssText));
    head.insertBefore(e, head.firstChild);
    return e;
}
function scrollEventHandler(event) {
    event.stopImmediatePropagation();
}
export function utilRaiseError(msg, useConsole = false) {
    if (useConsole) {
        if (typeof console !== "undefined")
            console.error("MUI Warning: " + msg);
    }
    else {
        throw new Error("MUI: " + msg);
    }
}
//# sourceMappingURL=util.js.map